import { Injectable } from '@angular/core';
import { ApiService, AuthService, KeyValuePair, ProviderName } from '@fgb/core';

@Injectable({
  providedIn: 'root',
})
export class PlayableService {
  constructor(private api: ApiService, private authService: AuthService) {}

  /**
   * This is used to SSO to the provider
   * @param url url paramater which can be changed to pass through a hard coded url or it will default to the one set in the settings
   *
   * @example
   * launchWebsite() {
   *  this.playableService.sso(1, 'www.google.co.uk')
   * }
   */
  sso(clubId: number, url?: string) {
    let options: KeyValuePair[] = [];
    if (url) {
      options = [{ key: 'Url', value: url }] as KeyValuePair[];
    }
    this.authService.loginThirdParty(ProviderName.Playable, clubId, '', false, options);
  }

  /**
   * Used when the user is returned from the provider to the UI
   * @param token the users external ref number
   */
  callback(token: string, options: KeyValuePair[]) {
    return this.api.post(`provider/${ProviderName.Playable}/ssocallback/${token}`, options).toPromise();
  }
}
